import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import { ActivationUserRequest, ApiService} from '../api/api.service';

@Injectable()
export class AdminResolver implements Resolve<Observable<ActivationUserRequest>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getActivtionUsersRequests();
  }
}
